import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { changeType, changeBuildings, changePrice, changeArea, setInitialValue } from '../../store/filterSlice';
import { updateApartmentsToParams } from '../../../ApartmentsList';

import Parameters from '../Parameters/Parameters';

import SelectItem from '../../../../ui/SelectItem';
import RangeSlider from '../../../../ui/RangeSlider';

export const Filters = () => {
	const {type, buildings, price, area, typeOptions, buildingOptions, sort} = useSelector((state) => state.filters);
	let payload = {type, buildings, price, area, sort};

	const dispatch = useDispatch();

	const isEnglish = document.body.classList.contains('en');
	
	useEffect(() => {
		dispatch(setInitialValue());
	}, []);
	
	const onChange = (typeAction, value) => {
		let payload = {type, buildings, price, area, sort};

		switch(typeAction) {
			case 'type':
				dispatch(changeType(value.value));
				payload.type = value.value;
				break;
			case 'buildings':
				const buildings = value.map(build => build.value);
				dispatch(changeBuildings(buildings));
				payload.buildings = buildings;
				break;
			case 'area':
				dispatch(changeArea(value));
				payload.area = value;
				break;
			case 'price':
				dispatch(changePrice(value));
				payload.price = value;
				break;
			default:
				break;
		}
	}

	useEffect(() => {
		dispatch(updateApartmentsToParams(payload));
	}, [type, buildings, price, area, sort]);

	return (
		<>
			{typeOptions && buildingOptions &&
				<ul className='filters'>
					<li>
						<span>{isEnglish ? 'Property type' : 'Тип недвижимости'}</span>
						<SelectItem options={typeOptions} value={typeOptions[type]} onChange={(value) => onChange('type', value)} placeholder={typeOptions[0]?.label} />
					</li>
					<li>
						<span>{isEnglish ? 'Building' : 'Корпус'}</span>
						<SelectItem options={buildingOptions} multi isMulti onChange={(value) => onChange('buildings', value)} placeholder={isEnglish ? 'All buildings' : 'Все корпуса'} />
					</li>
					<li>
						<span>{isEnglish ? 'Area' : 'Площадь'}, {isEnglish ? 'm²' : 'м²'}</span>
						<RangeSlider
							min={area.minDefault}
							max={area.maxDefault}
							onChange={(value) => onChange('area', value)}
							type='area'
						/>
					</li>
					<li>
						<span>{isEnglish ? 'Price' : 'Стоимость'}, ฿</span>
						<RangeSlider
							min={price.minDefault}
							max={price.maxDefault}
							onChange={(value) => onChange('price', value)}
							type='price'
						/>
					</li>
				</ul>
			}
			<Parameters />
		</>
	);
};
